/** Cleared on parent login so Home can auto-open add-child when appropriate. */
export const PARENT_DASHBOARD_DISMISS_ADD_CHILD_KEY = 'parentDashboardDismissAddChild';

/** Set at signup: coding | mathematics | other — drives which enroll modal opens on first home visit. */
export const PARENT_POST_SIGNUP_ENROLLMENT_KEY = 'parentPostSignupEnrollment';
